<template>
  <div v-if="eligibleCampaign" class="prakerja-gamification" data-testid="prakerja-gamification">
    <img
      :src="bannerMweb"
      alt="gamification-banner"
      width="100%"
      height="270"
      class="prakerja-gamification__bg"
      data-testid="gamification-banner"
    />
    <div class="prakerja-gamification__body">
      <div class="prakerja-gamification__progress-bar">
        <PrakerjaProgressBar :check-point-item="checkPointItem" data-testid="gamification-progressbar" />
      </div>
      <BlButtonAv
        variation="naked"
        class="prakerja-gamification__btn"
        data-testid="gamification-button"
        @click="onClickGamificationHomePage"
      >
        <IcoChevronRightMinor slot="icon" color="#332F9E" />
      </BlButtonAv>
    </div>
  </div>
</template>
<script>
import prakerjaGamification from 'src/shared/mixins/prakerja-gamification';
import PrakerjaProgressBar from 'shared/components/PrakerjaProgressBar/PrakerjaProgressBar';
import {BlButtonAv} from '@bukalapak/bazaar-mweb-latest';
import {IcoChevronRightMinor} from '@bukalapak/bazaar-visual-next';
import {TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_ENTRYPOINT} from '../../config/tracker-events';
import trackerGenerator from '../../mixins/tracker-generator';

export default {
  name: 'PrakerjaGamification',
  components: {
    PrakerjaProgressBar,
    BlButtonAv,
    IcoChevronRightMinor,
  },
  mixins: [prakerjaGamification, trackerGenerator],
  watch: {
    eligibleCampaign(value) {
      if (value) {
        this.trackViewGamification();
      }
    },
  },
  methods: {
    onClickGamificationHomePage() {
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_ENTRYPOINT, {
        source: 'home_page',
        action: 'click_gamification_entry_point',
      });
      this.navigateToGamificationHomePage();
    },
    trackViewGamification() {
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_ENTRYPOINT, {
        source: 'home_page',
        action: 'impress_gamification_entry_point',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.prakerja-gamification {
  min-height: 270px;
  display: flex;
  justify-content: center;
  align-items: end;
  .prakerja-gamification__bg {
    position: absolute;
    z-index: -1;
  }
  .prakerja-gamification__body {
    position: relative;
    display: flex;
    justify-content: center;
    padding-bottom: 24px;
    width: 100%;
  }
  .prakerja-gamification__progress-bar {
    background: #fff;
    border-radius: 12px;
    padding: 8px 32px 8px 8px;
    width: 88%;
  }
  .prakerja-gamification__btn {
    position: absolute;
    right: 12px;
    top: 26%;
    border-radius: 100px;
    border: 2px solid #332f9e;
  }
}
</style>
